

































































































































































































import AbpBase from "../../../../lib/abpbase";
import {Component, Vue, Inject, Prop, Watch} from 'vue-property-decorator';
import {
	GetMachineListByWardOrChangJ,
	InsertMachine,
	UpdateMachineById,
	DeleteMachine
} from '../../../../api/engineer'
import {GetMachineChangJList, GetMachineModelList, GetWardList} from "@/api/specialDictionary"
import Disinfection from './disinfection'
import Repair from './repair'
import Maintenance from './maintenance'
@Component({
	components: {Disinfection, Repair, Maintenance}
})
export default class Area extends AbpBase {
	cancel(){
		this.dialogFormVisible = false
	}
	visibleChange(value: boolean) {
		if (!value) {
			this.dialogFormVisible = false;
			(this.$refs.form as any).resetFields()
			this.getData()
		}
	}
	columns = [
		{
			key: 'machineName',
			title: '透析机名称'
		},
		{
			key: 'changJ',
			title: '厂家'
		},
		{
			key: 'machineType',
			title: '透析机类型'
		},
		{
			key: 'wardName',
			title: '病区'
		},
		{
			key: 'status',
			title: '是否启用',
			render:(h:any, p:any)=>{
				return h('span', p.row.status ? '启用' : '禁用')
			}
		},
		{
			key: 'spare',
			title: '备注'
		},
		{
			key: '',
			width: 320,
			title: '操作',
			render:(h:any, p:any)=>{
				return h('div', [
					h('Button',{
						props:{type: 'primary',size: 'small'},
						style:{marginRight:'10px'},
						on:{
							click:()=>{
								this.disinfection(p.row)
							}
						}
					},'消毒'),
					h('Button',{
						props:{type: 'primary',size: 'small'},
						style:{marginRight:'10px'},
						on:{
							click:()=>{
								this.repair(p.row)
							}
						}
					},'维修'),
					h('Button',{
						props:{type: 'primary',size: 'small'},
						style:{marginRight:'10px'},
						on:{
							click:()=>{
								this.maintenance(p.row)
							}
						}
					},'保养'),
					h('Button',{
						props:{type: 'primary',size: 'small'},
						style:{marginRight:'10px'},
						on:{
							click:()=>{
								this.edit(p.row)
							}
						}
					},'编辑'),
					h('Button',{
						props:{type: 'error',size: 'small'},
						on:{
							click:()=>{
								this.del(p.row)
							}
						}
					},'删除'),
				])
			}
		},
	]
	key = '' //查询条件
	page = 1 //当前页
	dialogTitle = ''
	dialogForm: any = {}
	dialogFormVisible = false
	dialogFormLabelWidth = '120px'
	tableTotalSize = 0
	tableData = []
	tableLoading = false
	repireShow = false
	maintenanceShow = false
	disinfectionShow = false
	status = ''
	cj = ''
	wards = []	//
	changJs = []  //厂家下拉
	models = []  //型号下拉
	WardID = '0'
	ChangJID = '0'

	created() {
		this.getData()
		this.getSelects()
	}

	//维修
	repair(row: any) {
		this.dialogForm = Object.assign({}, row)
		this.repireShow = true
	}

	//保养
	maintenance(row: any) {
		this.dialogForm = Object.assign({}, row)
		this.maintenanceShow = true
	}

	//消毒
	disinfection(row: any) {
		this.dialogForm = Object.assign({}, row)
		this.disinfectionShow = true
	}

	createCounty() {
		this.dialogTitle = '新增透析机'
		this.dialogForm = {status: true}
		this.dialogFormVisible = true
	}

	private async getData() {
		this.tableLoading = true
		let queryData:any = {
			QueryString: this.key,
			SkipCount: this.page,
			MaxResultCount: 10
		}
		if (!!this.ChangJID) {
			queryData.ChangJID = this.ChangJID
		}
		if (!!this.WardID) {
			queryData.WardID = this.WardID
		}
		let res = await GetMachineListByWardOrChangJ(queryData)
		this.tableData = res.items
		this.tableTotalSize = res.totalCount
		this.tableLoading = false
	}

	handleClose(val: any) {
		if (!val) this.dialogFormVisible = false
	}

	async changjiaChange() {
		this.changJs.forEach((item: any) => {
			if (item.id === this.dialogForm.changJID) {
				this.dialogForm.changJ = item.text
			}
		})
		let res = await GetMachineModelList({ChangJID: this.dialogForm.changJID})
		this.models = res.items
	}

	wardChange(){
		this.wards.forEach((item: any) => {
			if (item.id === this.dialogForm.wardID) {
				this.dialogForm.wardName = item.wardName
			}
		})
	}

	edit(row: any) {
		this.dialogTitle = '编辑透析机'
		this.dialogForm = JSON.parse(JSON.stringify(row))
		this.dialogFormVisible = true
	}

	async del(row: any) {
		this.$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
			confirmButtonText: '确定',
			cancelButtonText: '取消',
			type: 'warning'
		}).then(async () => {
			let res = await DeleteMachine({Id: row.id})
			this.getData()
		}).catch(() => {

		});
	}

	async confirm() {
		(this.$refs.form as any).validate(async (valid:boolean)=>{
			if(valid){
				if (this.dialogTitle === '新增透析机') {
					let res = await InsertMachine(this.dialogForm)
				} else if (this.dialogTitle === '编辑透析机') {
					let res = await UpdateMachineById(this.dialogForm)
				}
				this.dialogFormVisible = false
				this.getData()
			}
		})

	}

	rules = {
		machineName: [{required: true, message: '请输入内容', trigger: 'blur'}],
		// machineModel: [{required: true, message: '请输入内容', trigger: 'blur'}],
		// countryWB:[{required: true, message: '请输入内容', trigger: 'blur'}],
	}

	pageChange(val: any) {
		this.page = val
		this.getData()
	}

	async getSelects() {
		let res = await GetWardList({
			SkipCount: 1,
			MaxResultCount: 10000
		})
		this.wards = res.items

		let res1 = await GetMachineChangJList({})  //生产厂家下拉
		this.changJs = res1.items
	}


}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/engineer/machine/parts/area.vue